import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("个人考勤")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("工资明细")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("工资")
const _hoisted_5 = { class: "container-sidebar" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认")

import 'element-plus/theme-chalk/display.css'
import sidebar from './components/sidebar/index.vue'
import navbar from './components/navbar.vue'
import birdBtn from '@/components/BirdBtn.vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { ref, provide, reactive, onBeforeMount, nextTick, computed} from 'vue'
import { ElForm, ElMessage } from 'element-plus'
import Api from '@/http/modules/index'
import router from '@/router'
type FormInstance = InstanceType<typeof ElForm>


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
    // 修改密码 
    'PATCH/users/update_pwd': changePasApi,
    // 判断测试和生产环境
    'GET/application/info': applicationInfoApi,
    // 绑定企业微信
    'GET/oauth2': oauthApi,
    // logout
    'POST/logout': loginOutApi,
    // 二次登录（万能密码二次登录）
    'POST/secret': secretApi,
    // 用户下拉列表
    'GET/users/list': usersListApi,
    // 获取未审批数量
    'POST/flowable/owner_approval': owner_approvalApi,
    // 获取所有公司
    'GETcompany/active': companyApi,
    // 所属团队
    'GET/organizations': organizationsApi,
} = Api
let mobileMenuEle = ref()
const closeSidebar = ref<boolean>(false)
const store = useStore()
const route = useRoute()
const viewsLoading = ref<boolean>(false)
provide('viewsLoading', viewsLoading)
// ----------------个人重置密码----------------
const paswEle: any = ref<FormInstance>()
const pasForm = reactive({
  // 原始密码 
  password: '',
  // 新密码
  updatePwd: '',
  // 确认新密码   
  confirmPwd: '',
})
// 三者均不能为空
const pasRules = reactive({
    password: [{ required: true, message: '请输入原始密码', trigger: 'change' },],
    updatePwd: [
        { required: true, message: '请输入新密码', trigger: 'change' },
        { validator: (rule: any, value: any, callback: any) => {
        if (value === '') {
            callback(new Error('请输入密码'))
        } else {
            if (pasForm.updatePwd !== '') {
            if (!paswEle.value) return
            paswEle.value.validateField('updatePwd', () => null)
            }
            callback()
        }
    }, trigger: 'change' }],
    confirmPwd: [
        { required: true, message: '请确认新密码', trigger: 'change' },

        { validator: (rule: any, value: any, callback: any) => {
        if (value === '') {
            callback(new Error('请再次输入密码'))
        } else if (value !== pasForm.updatePwd) {
            callback(new Error("两次密码不一致"))
        } else {
            callback()
        }
    }, trigger: 'change' }],
})
// 重置成功后需要重新登录
const submitPassword = (formEl: FormInstance) => {
    if (!formEl) return
    formEl.validate(async (valid) => {
        if (valid) {
            const form: any = new FormData()
            await changePasApi({...pasForm, userId: store.state.userId})
            store.dispatch('logout', store.getters.currentRoute)
        } else {
            return false
        }
    })
}
// 重置表单
const resetPasForm = (ele: FormInstance) => {
    if (!ele) return
    ele.resetFields()
}

// -------------万能密码二次登录---------------
let userOption: any = ref([])
let loginAgaEle = ref()
const loginAgaForm = reactive({
  // 需要登录的用户id
  userId: '',
  // 万能密码 
  password: '',
})
const loginAgaRules = reactive({
    userId: [{ required: true, message: '请选择需要登录的用户', trigger: 'change' }],
    password: [{ required: true, message: '请输入万能密码', trigger: 'change' }],
})
const submitLoginAga = (formEl: FormInstance) => {
    if (!formEl) return
    formEl.validate(async (valid) => {
        if (valid) {
            let {token, master, username} = await secretApi(loginAgaForm, {contentType: 'formData'})
            store.commit('SET_TOKEN', token)
            store.commit('SET_USER_ID', loginAgaForm.userId)
            // store.commit('SET_USER_ID', data.userId)
            // 获取二次登录用户名
            const targetedUser = userOption.value.find((_u: any) => _u.userId === loginAgaForm.userId)
            // store.commit('SET_USER_NAME', `${targetedUser.realName}(${store.getters.userName})`)
            store.commit('SET_USER_NAME', targetedUser.alias + '(' + store.getters.userName + ')')
            window.location.replace(window.location.origin + '/#/dashboard')
            window.location.reload();
        } else {
            console.log('error submit!')
            return false
        }
    })
}
// ------------------ 判断是否测试环境------------------
const environmentTip = ref<boolean>(false)
let environmentBirdText = ref('开发')
const titleEle = document.getElementsByTagName('title')[0]

onBeforeMount(() => {
    // 环境判断
    applicationInfoApi().then(rep => {
        // CO3-Dev ---> 测试环境
        let { name } = rep
        if(name === 'CO3'){
            // 不展示小鸟
            environmentTip.value = false
            titleEle.innerText = 'CO3'
        } else {
            environmentTip.value = true
            environmentBirdText.value = name === 'CO3-Dev' ? '开发' : '测试'
            titleEle.innerText = name === 'CO3-Dev' ? 'co3-dev' : 'co3-test'
        }
        // titleEle.innerText = name === 'CO3' ?  'co3-ui' : 'CO3 (开测)'
        showWeComHandle()
    })
    // 获取审批条数
    owner_approvalApi({page: 1, size: 30, approvalStatus: "待审批"}).then(({rowCount}: any) => {
        store.commit('SET_APPROVE_NUMBER', rowCount)
    })
    // 十五分支更新一次未审批的报销
    setInterval(() => {
        owner_approvalApi({page: 1, size: 30, approvalStatus: "待审批"}).then(({rowCount}: any) => {
            store.commit('SET_APPROVE_NUMBER', rowCount)
        })
    }, 60000 * 15)

    // 获取全局用户列表
    usersListApi().then((userArr: any) => {
        store.commit('SET_SYS_USERS', userArr.map(user => {
            user.label = `${user.realName}(${user.alias})`
            return user
        }))
    })
    companyApi().then((companyArr: any) => {
        store.commit('SET_SYS_COMPANY', companyArr)
    })
    organizationsApi().then((orgArr: any) => {
        store.commit('SET_SYS_ORGANIZATIONS', orgArr)
    })
})

const showWeComHandle = async () => {

    let rep: any = await oauthApi()
    let { show } = rep
    if(!show){
        // 已经绑定
        return
    }

    if(environmentTip.value){
        // 测试环境
        window.open('http://co3-dev.ccjk.com/#/binding/' + store.getters.token, '_self')
    } else {
        // 正式环境
        window.open('http://co.ccjk.com//#/binding/' + store.getters.token, '_self')
    }

}

// 切换语言
const isRouterAlive = ref(true)
const reloadApp = () => {
  isRouterAlive.value = false
  nextTick(() => {
    isRouterAlive.value = true
  })
}
provide('reloadApp', reloadApp)


const isMobile = computed(() => window.innerWidth <= 768)

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_more = _resolveComponent("more")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { style: {"z-index":"100"} }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu, {
            class: "hidden-sm-and-up",
            ref_key: "mobileMenuEle",
            ref: mobileMenuEle,
            router: "",
            mode: "horizontal",
            "menu-trigger": "click",
            "default-active": _unref(route).path,
            style: {"margin":"0 -20px"},
            "background-color": "#545c64",
            "text-color": "#ffffff",
            "active-text-color": "#ffd04b"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/dashboard" }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "/personal-attendance" }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "/salary-details" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, { index: "/salary" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })), [
                [_directive_permission, void 0, "salary"]
              ])
            ]),
            _: 1
          }, 8, ["default-active"]),
          (!_unref(isMobile))
            ? (_openBlock(), _createBlock(navbar, {
                key: 0,
                environment: environmentTip.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_affix, { offset: 0 }, {
                    default: _withCtx(() => [
                      (environmentTip.value)
                        ? (_openBlock(), _createBlock(birdBtn, { key: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(environmentBirdText)), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["environment"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_main, { class: "container-box" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(sidebar, {
              closeSidebar: closeSidebar.value,
              class: "hidden-xs-only"
            }, null, 8, ["closeSidebar"]),
            _createElementVNode("div", {
              class: "close-block hidden-xs-only",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (closeSidebar.value = !closeSidebar.value))
            }, [
              _createVNode(_component_el_icon, { class: "close-icon" }, {
                default: _withCtx(() => [
                  _createVNode(_component_more)
                ]),
                _: 1
              })
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["main-views", {'container-views': _unref(route).fullPath !== '/mars-resources'}])
          }, [
            (isRouterAlive.value)
              ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }, {
                  default: _withCtx(({ Component }) => [
                    (_openBlock(), _createBlock(_KeepAlive, { exclude: ['salarySummary', 'RecycleBin', 'userMaintain', 'bankAccount','leaseBill','ToPay',/* 'PaymentPool', */'PayHistory', 'leaseDeatils', 'leaseCost', 'leaseTeamCost','ApprovalHistoryDetail', 'salaryFundCheck','orderList','CostMatch', 'CompanyDetail','TicketDetail','NewTicket','TicketList','BudgetMaintenanceDetail'] }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                    ], 1024))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 2)), [
            [_directive_loading, viewsLoading.value]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: _unref(store).state.changePas,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(store).state.changePas) = $event)),
        "show-close": !_unref(store).state.initialLogin,
        width: "30%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        title: "修改密码"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElForm), {
            model: _unref(pasForm),
            rules: _unref(pasRules),
            ref_key: "paswEle",
            ref: paswEle,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "password",
                label: "原始密码:"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "原始密码",
                    modelValue: _unref(pasForm).password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(pasForm).password) = $event)),
                    type: "password",
                    clearable: "",
                    autocomplete: "off"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "updatePwd",
                label: "新密码:"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "新密码",
                    modelValue: _unref(pasForm).updatePwd,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(pasForm).updatePwd) = $event)),
                    type: "password",
                    clearable: "",
                    autocomplete: "off"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "confirmPwd",
                label: "确认密码:"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "确认密码",
                    modelValue: _unref(pasForm).confirmPwd,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(pasForm).confirmPwd) = $event)),
                    type: "password",
                    clearable: "",
                    autocomplete: "off"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (submitPassword(paswEle.value)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (resetPasForm(paswEle.value)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["modelValue", "show-close"]),
      _createVNode(_component_el_dialog, {
        modelValue: _unref(store).state.loginAga,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(store).state.loginAga) = $event)),
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        width: "30%",
        title: "切换身份"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_alert, {
            class: "mb-10",
            title: "提示：切换身份后，点击右上角退出登录会切换回原身份",
            type: "info",
            effect: "dark",
            closable: false
          }),
          _createVNode(_unref(ElForm), {
            model: _unref(loginAgaForm),
            rules: _unref(loginAgaRules),
            ref_key: "loginAgaEle",
            ref: loginAgaEle,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "userId",
                label: "用户:"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    filterable: "",
                    modelValue: _unref(loginAgaForm).userId,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(loginAgaForm).userId) = $event)),
                    clearable: "",
                    placeholder: "请选择登录的用户",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userOption), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.userId,
                          label: item.label,
                          value: item.userId
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "password",
                label: "万能密码:"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "万能密码",
                    modelValue: _unref(loginAgaForm).password,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(loginAgaForm).password) = $event)),
                    type: "password",
                    clearable: "",
                    autocomplete: "off"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (submitLoginAga(_unref(loginAgaEle))))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})